import _classCallCheck from "/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isValidTimeout, isServer } from './utils.mjs';
var Removable = /*#__PURE__*/function () {
  function Removable() {
    _classCallCheck(this, Removable);
  }
  _createClass(Removable, [{
    key: "destroy",
    value: function destroy() {
      this.clearGcTimeout();
    }
  }, {
    key: "scheduleGc",
    value: function scheduleGc() {
      var _this = this;
      this.clearGcTimeout();
      if (isValidTimeout(this.cacheTime)) {
        this.gcTimeout = setTimeout(function () {
          _this.optionalRemove();
        }, this.cacheTime);
      }
    }
  }, {
    key: "updateCacheTime",
    value: function updateCacheTime(newCacheTime) {
      // Default to 5 minutes (Infinity for server-side) if no cache time is set
      this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : isServer ? Infinity : 5 * 60 * 1000);
    }
  }, {
    key: "clearGcTimeout",
    value: function clearGcTimeout() {
      if (this.gcTimeout) {
        clearTimeout(this.gcTimeout);
        this.gcTimeout = undefined;
      }
    }
  }]);
  return Removable;
}();
export { Removable };